// Helpers

if (!Array.prototype.forEach) {
  Array.prototype.forEach = function (fn, scope) {
    'use strict';
    var i, len;
    for (i = 0, len = this.length; i < len; ++i) {
      if (i in this) {
        fn.call(scope, this[i], i, this);
      }
    }
  };
}

if (!Array.prototype.find) {
  Array.prototype.find = function(callback) {
    if (this === null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    } else if (typeof callback !== 'function') {
      throw new TypeError('callback must be a function');
    }
    var list = Object(this);
    // Makes sures is always has an positive integer as length.
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    for (var i = 0; i < length; i++) {
      var element = list[i];
      if ( callback.call(thisArg, element, i, list) ) {
        return element;
      }
    }
  };
}

var root = new Vue({
  el: '#root',
  delimiters: ['${', '}'],
  data: {
    domain: "https://www.malikafavre.com",
    domainShop: "https://shop.malikafavre.com",
    mobileNavOpened: false,
    legalPanelsActive: false,
    shippingOn: false,
    returnsOn: false,
    contactOn: false,
    latestPanel: null,
    warningPrevTitle: '',
    warningPrevMessage: '',
    newsletterPopupActive: false
  },
  computed: {
    warningCurrentTitle: function() {
      return window.warningTitle;
    },
    warningCurrentMessage: function() {
      return window.warningMessage;
    }
  },
  methods: {
    openLegalPanel: function(panel) {
      if (panel == this.latestLegalPanel) {
        this.closeLegalPanel();
        return;
      }
      this.latestLegalPanel = panel;
      this.shippingOn = false;
      this.returnsOn = false;
      this.contactOn = false;
      if (panel == 'shipping') {
        this.shippingOn = true;
      } else if (panel == 'returns') {
        this.returnsOn = true;
      } else if (panel == 'contact') {
        this.contactOn = true;
      } else {
        this.shippingOn = true;
        this.returnsOn = true;
        this.contactOn = true;
      }
      this.legalPanelsActive = true;
    },
    closeLegalPanel: function() {
      this.shippingOn = false;
      this.returnsOn = false;
      this.contactOn = false;
      this.legalPanelsActive = false;
      this.latestLegalPanel = null;
    },
    isWarningAknowledged: function() {
      return (this.warningCurrentTitle == '' && this.warningCurrentMessage == '') || (this.warningCurrentTitle == this.warningPrevTitle && this.warningCurrentMessage == this.warningPrevMessage);
    },
    closeWarning: function() {
      this.warningPrevTitle = this.warningCurrentTitle;
      this.warningPrevMessage = this.warningCurrentMessage;
      localStorage.setItem('warningTitle', this.warningPrevTitle);
      localStorage.setItem('warningMessage', this.warningPrevMessage);
    },
    updateVariantPrice: function(e, handle) {
      var opt = e.target.options[e.target.selectedIndex];
      var list = document.getElementsByClassName("price");
      for (var i=0; i<list.length; i++) {
        list[i].innerHTML = opt.dataset.price;
      }
    },
    closeNewsletterPopup: function(e) {
      e.preventDefault();
      this.newsletterPopupActive = false;
      var now = new Date();
      var ttl = 24 * 60 * 60 * 1000;
      var newsletterDiscardedUntil = now.getTime() + ttl;
	  localStorage.setItem('newsletterDiscardedUntil', JSON.stringify(newsletterDiscardedUntil));
    }
  },
  mounted: function() {
    if (localStorage.getItem('warningTitle') && localStorage.getItem('warningMessage')) {
      this.warningPrevTitle = localStorage.getItem('warningTitle');
      this.warningPrevMessage = localStorage.getItem('warningMessage');
    }
    var mustShowNewsletterPopup = false;
    var currentJson = localStorage.getItem('newsletterDiscardedUntil');
    if (!currentJson) {
      mustShowNewsletterPopup = true;
    } else {
      var currentValue = JSON.parse(currentJson);
      var now = new Date();
      mustShowNewsletterPopup = now.getTime() > currentValue;
      //mustShowNewsletterPopup = true;
    }
    if (mustShowNewsletterPopup) {
      var self = this;
      setTimeout(function() {
        self.newsletterPopupActive = true;
      }, 8000);
    }
  }
});

